export const NamePattern="^[a-zA-Z][a-zA-Z0-9-_\. ]{1,20}$";
export const EmailPattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";
